export default __webpack_public_path__ + "static/hero-splash-sq-9c44bc02ce94b941e006df6802fe686f.mp4";